module.exports = __webpack_public_path__ + "img/Image202308111330422.57bddeff.png";